import { render, staticRenderFns } from "./TransitInfo.vue?vue&type=template&id=4d52e8f1&scoped=true"
import script from "./TransitInfo.vue?vue&type=script&lang=js"
export * from "./TransitInfo.vue?vue&type=script&lang=js"
import style0 from "./TransitInfo.vue?vue&type=style&index=0&id=4d52e8f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d52e8f1",
  null
  
)

export default component.exports